<template>
  <aside class="nav-bar">
    <div class="profile">
      <figure>
        <img src="@/assets/logo_small.png" alt="SoulMatch">
      </figure>
    </div>
    <a id="fb" href="https://www.facebook.com/soulmatch2018/" target="_blank">Facebook</a>
    <a @click="modalOpen('QAmodal')">說明</a>
    <a @click="modalOpen('settingModal')">設定</a>
    <a @click="modalOpen('aboutModal')">關於</a>
  </aside>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  data() {
    return {};
  },
  methods: {
    ...mapMutations('modal',['modalOpen'])
  }
};
</script>

<style scoped lang="scss">
#fb {
  text-decoration: none;
}
#fb:hover {
  background-color: rgb(90, 132, 216);
  color: white;
}

.nav-bar {
  display: flex;
  align-items: center;
  position: fixed;
  flex-wrap: wrap;
  padding: 5px;
  z-index: 2;
  width: calc(100% - 60px);
  border-bottom-right-radius: 1em;
  background-color: rgba(250, 250, 250, 0.8);
  //  background-color: rgba(239, 239, 244, 0.8);
  .title {
    font-weight: bold;
    font-style: italic;
    padding: 5px;
    margin: 5px;
    font-family: monospace, fantasy, Arial, Helvetica, sans-serif;
  }
  .profile {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
  }
  h3 {
    padding: 10px;
  }
  a {
    padding: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    //    border-bottom:2px solid rgb(240,240,240);
    display: block;
  }
  a:hover {
    background-color: rgb(217, 217, 218);
    background-color: rgb(249, 205, 194);
    color: white;
    cursor: pointer;
  }
  img {
    border-radius: 5px;
    max-width: 45px;
    padding: 5px;
    box-sizing: content-box;
  }
  img:hover {
    background-color: rgb(249, 205, 194);
    color: white;
  }
}
</style>